<template>
    <div>
        <!--Account found-->
        <div class="alert alert-success" v-if="hasAccount">
            <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
            <strong><i class="fa fa-check"></i> Account Found</strong> We noticed you have a account. Please login
        </div>

        <!--No Account found-->
        <div class="alert alert-info" v-if="!hasAccount && submitted">
            <strong><i class="fa fa-question-circle"></i> Continue As Guest?</strong> We couldn't identify you as a
            {{tenantDomain ? tenantDomain.tenant.name : ''}} member.
            If you are not a member and would like to proceed, simply click "Continue As Guest"
        </div>

        <!--Incorrect login-->
        <div class="alert alert-danger" v-if="error">
            <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
            <strong><i class="fa fa-times"></i> Incorrect Login</strong> The login details were incorrect
        </div>


        <form role="form" lpformnum="3" v-on:submit.prevent="submit">
            <div class="form-group">
                <label for="exampleInputEmail1">Email address</label>
                <input type="email" class="form-control" v-model="email" :disabled="hasAccount" id="exampleInputEmail1"
                       placeholder="Enter email"
                       autocomplete="off">
            </div>
            <div class="form-group" v-if="hasAccount">
                <label for="exampleInputPassword1">Password</label>
                <input type="password" class="form-control" v-model="password" id="exampleInputPassword1"
                       placeholder="Password"
                       autocomplete="off">
            </div>
            <button type="submit" class="btn btn-ar btn-primary" :disabled="disabled"><i v-if="loading"
                                                                                         ref="primary-btn"
                                                                                         class="fa fa-spinner fa-spin"></i>
                {{buttonText}}
            </button>
            <button type="button" class="pull-right btn btn-ar btn-primary button-glow"
                    v-if="!hasAccount && submitted || hasAccount"
                    @click="continueNoLogin">
                <i v-if="loading" class="fa fa-spinner fa-spin"></i> Continue As Guest
            </button>
        </form>


    </div>
</template>

<script>

    import axios from "axios"

    // require this line otherwise ['X-Requested-With'] = 'XMLHttpRequest' does not get set
    window.axios = require('axios');

    export default {
        name: "loginOrGhost",
        props: {
            tenantDomain: {
                type: Object,
                required: false,
                default: null
            },
            redirect: {
                type: String,
                required: false,
                default: null
            },
            urlPrefix: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                email: '',
                password: '',
                hasAccount: false,
                error: false,
                disabled: true,
                buttonText: 'Proceed',
                submitted: false,
                loading: false
            }
        },
        watch: {
            // watch for changes
            email: function () {
                this.disabled = !this.email ? true : false;
            },
            password: function () {
                this.disabled = !this.password ? true : false;
            },
        },
        methods: {
            submit() {
                this.error = false;
                this.submitted = false;
                this.loading = true;
                if (!this.hasAccount) {
                    //Account exists check
                    axios.get(this.urlPrefix + '/api/internal/users/exists.json?email=' + this.email, {
                        headers: {
                            'Accept': 'application/vnd.api+json'
                        }
                    }).then(response => {
                        if (response.data === true) {
                            this.hasAccount = response.data;
                            this.buttonText = "Login & Proceed";
                        } else {
                            this.buttonText = "Lookup Account";
                            //Redirect the user to where they were trying to go
                            //window.location.href = 'http://bfr.local/participants/add/5?email=' + this.email;
                        }
                    }).catch(response => {
                        this.loading = false;
                    }).then(response => {
                        this.loading = false;
                        this.submitted = true;
                    })
                } else {
                    //Log the user in
                    axios.post(this.urlPrefix + '/api/internal/users/login.json',
                        {
                            email: this.email,
                            password: this.password
                        },
                        {
                            headers: {
                                'Accept': 'application/vnd.api+json'
                            }
                        }).then(response => {
                        console.log(response);
                        if (response.data.user) {
                            this.success = true;

                            // emit an event when user is authenticated
                            this.$emit('authenticated', response.data.user);

                            //Redirect the user to where they were trying to go
                            if (this.redirect != null) {
                                if (this.redirect === "reload") {
                                    window.location.reload();
                                } else if (this.redirect != null) {
                                    window.location.href = this.redirect;
                                }
                            }

                        } else {
                            this.loading = false;
                            this.error = true;
                        }
                    })
                }
            },
            continueNoLogin() {
                this.loading = true;
                //Log the user in
                axios.post(this.urlPrefix + '/api/internal/users/ghost.json',
                    {
                        email: this.email,
                        password: this.password
                    },
                    {
                        headers: {
                            'Accept': 'application/vnd.api+json',
                        }
                    }).then(response => {

                    if (response.data.success === true) {
                        this.success = true;

                        this.$emit('authenticated', response.data.user);

                        //Redirect the user to where they were trying to go
                        if (this.redirect != null) {
                            if (this.redirect === "reload") {
                                window.location.reload();
                            } else {
                                window.location.href = this.redirect;
                            }
                        }
                    } else {
                        this.loading = false;
                        this.error = true;
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Assets/components/Users/LoginOrGhost.vue